import { REGISTER_TASK, REGISTER_TASK_SUCCESSFUL, REGISTER_TASK_FAILED } from "./actionTypes";

export const registerTask = (task, history) => {
  return {
    type: REGISTER_TASK,
    payload: { task, history },
  };
};

export const registerTaskSuccessful = (msg) => {
  return {
    type: REGISTER_TASK_SUCCESSFUL,
    payload: msg,
  };
};

export const registerTaskFailed = (msg) => {
  return {
    type: REGISTER_TASK_FAILED,
    payload: msg,
  };
};
